import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DisableContextMenuDirective } from 'src/app/core/directives/disable-context-menu.directive';
import { WithFallbackImageDirective } from '../../../directives/with-fallback-image.directive';
import { AppInterface, ClickOnAppBehavior, DisplayType } from '../../../interfaces/app.interface';
import { BookmarkIconComponent } from '../../bookmark/bookmark-icon/bookmark-icon.component';

@Component({
  selector: 'icon',
  imports: [
    CommonModule,
    DisableContextMenuDirective,
    BookmarkIconComponent,
    WithFallbackImageDirective,
    TranslatePipe,
  ],
  templateUrl: './icon.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input({ required: true }) app!: AppInterface;
  @Input() displayType: DisplayType = DisplayType.SMALL;
  @Input() isUnpublished: boolean = false;
  @Output() appIconClicked: EventEmitter<void> = new EventEmitter<void>();
  protected readonly DisplayType = DisplayType;
  protected readonly ClickOnAppBehavior = ClickOnAppBehavior;

  protected handleClick() {
    this.appIconClicked.emit();
  }
}
